import { v4 as uuid } from "uuid";

export class CallingWaiterOrder {
  constructor({
    tableNum,
    employeeObjectNum,
    checkNumber,
    checkSeq,
    checkId,
    type,
    tenderMedia,
    callWaiterSku,
  }) {
    const createdAt = new Date();

    this.order = {
      id: uuid(),
      reference: uuid(),
      shortReference: uuid(),
      type: type,
      employeeObjectNum: employeeObjectNum,
      createdAt: createdAt,
      scheduled: false,
      discount: 0,
      discountCode: 0,
      discountInfo: "",
      checkNum: checkNumber,
      checkSeq: checkSeq,
      checkId: checkId,
      tableNum: tableNum,
      merchant: {},
      benefits: [],
      payments: [
        {
          name: "AUTOATENDIMENTO",
          code: "AA",
          value: 0,
          prepaid: true,
          issuer: "AUTOAT",
          collector: "AUTOAT",
          NSU: "",
          tenderMedia: tenderMedia,
        },
      ],
      customer: null,
      items: [
        {
          index: 0,
          id: callWaiterSku,
          externalId: callWaiterSku,
          externalCode: callWaiterSku,
          name: "Chamar Garçom",
          quantity: 1,
          price: 0,
          totalPrice: 0,
          discount: 0,
          discountCode: 0,
          discountInfo: "",
          addition: 0,
          subItemsPrice: 0,
          subItems: [],
          observations: "",
        },
      ],
      combos: [],
      subTotal: 0,
      deliveryFee: 0,
      totalPrice: 0,
      deliveryAddress: {},
      deliveryDateTime: null,
      preparationStartDateTime: createdAt,
      localizer: { id: 0 },
      preparationTimeInSeconds: 0,
      isTest: true,
      deliveryMethod: {},
    };
  }

  export() {
    return this.order;
  }
}
